<!--
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-07 10:03:48
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-21 18:55:32
-->
<template>
  <section>
    <div class="role roleRight_box">
      <div class="roleRight" style="border-left: 0">
        <div class="roleRight_Top">
          <el-input
              v-if="searchShow"
              clearable
              v-model="search.searchKey"
              clas="input_search"
              placeholder="搜索关键字"
              @keyup.enter.native="SearchPostList"
          ></el-input>
          <el-select v-if="searchShow" v-model="search.status" clearable placeholder="请选择">
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
          <el-button v-if="searchShow" size="medium" type="primary" @click="SearchPostList"
          >查询
          </el-button
          >
          <el-button
              v-if="addShow"
              size="medium"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data car_post">
          <el-table default-expand-all row-key="feedbackTypeId" :tree-props="{ children: 'children' }" v-loading="loading" :data="tableData"
                    size="medium" border>
            <el-table-column style="text-align: left !important;" prop="fbName" label="名称" min-width="200">
            </el-table-column>
            <el-table-column prop="seq" label="排序" width="80">
            </el-table-column>
            <el-table-column prop="status" label="状态" width="80">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.status"
                    :active-value="1"
                    :disabled="statusShow"
                    :inactive-value="0"
                    @change="handleSwitch(scope.row)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column width="180" v-if="editShow || deleteShow" fixed="right" label="操作">
              <template slot-scope="scope">
                <el-button
                    v-if="editShow"
                    @click="handleClick('change', scope.row)"
                    plain
                    size="small"
                >修改
                </el-button
                >
                <el-button
                    v-if="deleteShow"
                    type="primary"
                    plain
                    size="small"
                    @click="del(scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="新增/编辑反馈类型"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="650px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="100px"
        >
          <el-form-item label="上级：" style="position: relative">
            <el-select
                v-model="dictDataSelect"
                placeholder="请选择"
                ref="selectReport"
                style="width: 315px"
                clearable
                filterable
                @clear="changBind"
            >
              <el-option
                  :key="params.feedbackTypeId"
                  :value="params.feedbackTypeId"
                  :label="params.feedbackTypeId"
                  style="height: auto"
              >
                <el-tree
                    :data="tableData"
                    node-key="feedbackTypeId"
                    ref="TreeList"
                    :props="treeProps"
                    :render-after-expand="true"
                    :expand-on-click-node="false"
                    @node-click="handleNodeClick"
                ></el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
              class="item"
              label="名称："
              prop="fbName"
          >
            <el-input
                clearable
                style="width: 472px"
                placeholder="请填写名称"
                v-model="params.fbName"
            ></el-input>
          </el-form-item>
          <el-form-item
              class="item"
              label="说明："
          >
            <el-input
                clearable
                style="width: 472px"
                :rows="4"
                type="textarea"
                placeholder="请填写说明"
                v-model="params.fbDescr"
            ></el-input>
          </el-form-item>
          <el-form-item
              class="item"
              label="排序："
          >
            <el-input
                clearable
                style="width:172px"
                placeholder="请填写排序"
                v-model="params.seq"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>
<script>
import {PAGE_SIZE} from "@/config";
import richText from "../../components/richText";

export default {
  components: {
    richText
  },
  data() {
    return {
      flag: false,
      PAGE_SIZE,
      loading: false,
      dictDataSelect:'',
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      treeProps: {
        //配置选项:此处定义el-tree的label和children为指定属性，  如果不定义取默认，即label和children
        // value: "parentId",
        children: "children",
        label: "fbName",
      },
      search: {},
      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {
        parentId:0
      },
      rules: {
        fbName: [
          {required: true, message: "请填写名称", trigger: "change"},
        ],
      }, //表单验证提示
      tableData: [], //列表
      srcList: [],
      isMoer: true,

      searchShow: false,
      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
    };
  },
  async created() {
    this.getRoleListTree();
    await this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.flag = false
        this.dictDataSelect = ''
      }
    },
    search: {
      handler(val) {
      },
      deep: true,
    },
  },
  methods: {
    changBind(){
       this.params.parentId = 0
    },

    handleNodeClick: function (node) {
      this.dictDataSelect = node.fbName;
      this.params.feedbackTypeId = node.feedbackTypeId;
      this.params.parentId = node.feedbackTypeId;
      this.$refs.selectReport.blur();
    },
    //switch状态改变 --接口 修改管理员状态
    handleSwitch(row) {
      this.$put(`/feedback/type/info/status/${row.feedbackTypeId}`).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
        }
      });
    },

    //权限处理
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'basics:feedback:query') {
            this.searchShow = true
          }
          if (item.code == 'basics:feedback:add') {
            this.addShow = true
          }
          if (item.code == "basics:feedback:delete") {
            this.deleteShow = true
          }
          if (item.code == "basics:feedback:edit") {
            this.editShow = true
          }
          if (item.code == "basics:feedback:status") {
            this.statusShow = false
          }
        })
      }
    },
    //筛选
    SearchPostList() {
      this.page.pageNo = 1
      this.getRoleListTree()
    },
    /**
     *  获取列表
     */
    async getRoleListTree(data, checked) {
      let http = `/feedback/type/list`;
      this.loading = true;
      const {data: resData} = await this.$get(http, {
        params: {...this.search, ...this.page},
      });
      this.loading = false;
      this.tableData = resData.data;
    },
    // 弹窗
    async handleClick(type, row = {}) {
      this.clickType = type;
      if (type == "change") {
        this.loading = true;
        const {data: resData} = await this.$get('/feedback/type/info/' + row.feedbackTypeId);
        this.loading = false;
        this.$nextTick(() => {
          //回显上一级
          let temp = this.$refs.TreeList.getNode(row.feedbackTypeId).parent.data.fbName
          this.dictDataSelect = temp
        })
        // //修改  change
        this.params = resData.data;
        this.dialogVisible = true;
        this.flag = true
      } else {
        //添加
        this.params = {};
        this.flag = true
        this.dialogVisible = true;
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        let passData = this.params;
        if (!valid) return;
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "addNext") {
            const {data: resData} = await this.$post("/feedback/type/info", passData, {
              headers: {
                isLoading: true,
              },
            });
            if (resData.result != 200) return;
            this.getRoleListTree(); //重新获取数据
            this.dialogVisible = false; //弹窗隐藏
            this.params = {
              content: ''
            };
            this.flag = false
            this.$message.success("添加成功!");
          } else if (this.clickType == "change") {
            //修改岗位
            const {data: resData} = await this.$put(
                "/feedback/type/info",
                passData,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.getRoleListTree(); //重新获取数据
            this.dialogVisible = false; //弹窗隐藏
            this.params = {
              content: ''
            };
            this.flag = false
            this.$message.success("修改成功!");
          }
        });
      });
    },
    //删除
    del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/feedback/type/info/${row.feedbackTypeId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getRoleListTree();
        this.$message.success("删除成功!");
      });
    },
    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getRoleListTree();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getRoleListTree();
    },
  },
};
</script>

<style lang="scss" scoped>
.clear_icon_items {
  color: #F56C6C;
  position: absolute;
  left: -64px;
  top: 0;
}

.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Left {
    width: auto;
    padding-right: 15px;

    &_List {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 20px;
    }
  }

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    border-left: 1px solid #ccc;
    padding-left: 15px;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
</style>


<style lang="scss">
.roleRight_box .car_post .el-table .el-table_1_column_1 {
  text-align: left !important;
}
.roleRight_box .car_post .el-table tbody tr td:nth-child(1){
  text-align: left !important;
}
.roleRight_box .car_post .el-table .el-table_1_column_1 {
  text-align: left !important;

  .disabled_tab {
    .el-switch__core {
      background-color: #606266 !important;
      border-color: #606266 !important;
    }
  }
}

</style>